import UpgradeAccountButton from '@/components/subscription/UpgradeAccountButton';
import { HeroSlideLayout } from './HeroSlideLayout';

export const SubscriptionCTASlide = () => {
    return (
        <HeroSlideLayout
            title="Desbloqueie todo o potencial"
            description="Assine um plano e tenha acesso completo a exportação de laudos, geração com IA e muito mais."
            action={
                <UpgradeAccountButton
                    className="h-10 w-full sm:h-11 sm:w-auto"
                    labelClassName="text-sm sm:text-base"
                />
            }
        />
    );
};
